var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentMp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6,13H4V2H15l5,5v6H18V7.83L14.17,4H6Zm15.00079,5.6709V19.642h-.81v1.364h-1.309V19.642H15.99982V18.582L18.60181,15h1.589v3.6709Zm-2.086-2.407-1.665,2.407h1.665ZM6.742,18.24719c-.102.313-.219.718-.352,1.212-.132-.5-.249-.90405-.347-1.212L5.005,15.00024H3V21.0061H4.25V16.14417c.138.51794.259.933.36,1.24694l1.17,3.615H6.941l1.204-3.71692c.124-.379.235-.76.33-1.145V21.0061H9.777V15.00024H7.794Zm8.45173-2.42492a1.91146,1.91146,0,0,1,.268,1.022,1.763,1.763,0,0,1-.636,1.46191,1.6842,1.6842,0,0,1-.668.316,4.431,4.431,0,0,1-1.011.095h-.567V21.0061h-1.353V15.00024h1.692a5.76132,5.76132,0,0,1,1.318.114A1.52029,1.52029,0,0,1,15.19373,15.82227Zm-1.085,1.06884a.77047.77047,0,0,0-.351-.71692,1.64149,1.64149,0,0,0-.823-.156h-.389v1.682h.389a2.00451,2.00451,0,0,0,.81-.119A.6925.6925,0,0,0,14.1087,16.89111Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentMp);
export default __webpack_public_path__ + "static/media/Document-MP.31235709.svg";
export { ForwardRef as ReactComponent };